module.exports = __webpack_public_path__ + "static/media/final_background_mobile.64093daf.png";